import { IKeHoachMonGhepCapSelectRequest } from "../../model/request/ke-hoach/IKeHoachMonGhepCapSelectRequest";
import { IKeHoachMonGhepCap } from "../../model/respone/ke-hoach/IKeHoachMonGhepCap";
import { apiClient } from "../apiClient";

export const KE_HOACH_MON_GHEP_CAP_ENDPOINT = "ghep-cap";

export const keHoachMonGhepCapApi = {
    SelectByNamHoc: (request: IKeHoachMonGhepCapSelectRequest) => apiClient.get(`${KE_HOACH_MON_GHEP_CAP_ENDPOINT}/nam-hoc/${request.nam_hoc}/hoc-ky/${request.hoc_ky}`),
    Saves: (request: IKeHoachMonGhepCap[]) => apiClient.put(`${KE_HOACH_MON_GHEP_CAP_ENDPOINT}`, request),
};
